<nav class="navbar navbar-expand-lg navbar-transparent  navbar-absolute fixed-top">
  <a class="navbar-brand" href="#">
    <img src="{{ images.logo }}" width="" height="60" alt="">
  </a>
  <div class="container-fluid">
    <div class="icon-menu" (click)="openMenu()">
      <mat-icon class="material-icons">menu</mat-icon>
    </div>
    <app-notification></app-notification>
    <div class="user">
      <div class="image" (click)="openUserMenu = !openUserMenu">
        <img src="{{ photo }}" alt="user">
      </div>
      <div class="user-menu" *ngIf="openUserMenu">
        <p (click)="logout()" class="name">{{ 'auth.logout' | translatePipe }}</p>
      </div>
    </div>
    <!--
    <div class="navbar-wrapper">
      <app-select-language></app-select-language>
    </div> -->
  </div>
</nav>
